// locales/index.ts

// Импорт языковых пакетов для DataGrid
import {
  ukUA as DataGridUkUA,
  enUS as DataGridEnUS,
  plPL as DataGridPlPL,
  deDE as DataGridDeDE,
  ruRU as DataGridRuRU,
  roRO as DataGridRoRO,
} from '@mui/x-data-grid/locales';

// Импорт языковых пакетов для LocalizationProvider
import {
  ukUA as LocalizationProviderUkUA,
  enUS as LocalizationProviderEnUS,
  plPL as LocalizationProviderPlPL,
  deDE as LocalizationProviderDeDE,
  ruRU as LocalizationProviderRuRU,
  roRO as LocalizationProviderRoRO,
} from '@mui/x-date-pickers/locales';

// Создаем объект с локалями, разделяя их по компонентам
const locales = {
  uk: {
    dataGrid: DataGridUkUA,
    localizationProvider: LocalizationProviderUkUA,
  },
  en: {
    dataGrid: DataGridEnUS,
    localizationProvider: LocalizationProviderEnUS,
  },
  pl: {
    dataGrid: DataGridPlPL,
    localizationProvider: LocalizationProviderPlPL,
  },
  de: {
    dataGrid: DataGridDeDE,
    localizationProvider: LocalizationProviderDeDE,
  },
  ru: {
    dataGrid: DataGridRuRU,
    localizationProvider: LocalizationProviderRuRU,
  },
  ro: {
    dataGrid: DataGridRoRO,
    localizationProvider: LocalizationProviderRoRO,
  },
};

export type LocaleKey = keyof typeof locales;
export default locales;